module.exports = __webpack_public_path__ + "img/logoblizzert.a1561ad0.png";